import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CmsConfig, provideConfig } from '@spartacus/core';
import { CustomStoreFinderComponent } from './custom-store-finder.component';
import { AddressesWithMapComponent } from './components/addresses-with-map/addresses-with-map.component';
import { StoreFinderFormComponent } from './components/store-finder-form/store-finder-form.component';
import { PageTitle } from '../../store-front/misc/page-title/page-title.component';
import { pointOfServicesOccConfig } from './core/custom-store-finder.occ';

@NgModule({
  declarations: [CustomStoreFinderComponent],
  imports: [CommonModule, PageTitle, AddressesWithMapComponent, StoreFinderFormComponent],
  providers: [
    provideConfig(pointOfServicesOccConfig),
    provideConfig(<CmsConfig>{
      cmsComponents: {
        StoreLocatorComponent: {
          component: CustomStoreFinderComponent,
        },
      },
    }),
  ],
})
export class CustomStoreFinderModule {}
